module.exports = __webpack_public_path__ + "static/img/qingquneiyhaibao.0ad2181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/qqly/qingquneiyhaibao.png
// module id = eXQZ
// module chunks = 0